module.exports = __webpack_public_path__ + "static/media/hoy.500b27a2.png";